import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';

import { DISCLAIMER_CONSULTATION_RESULTS_INGREDIENTS_CANCEL } from 'consts/copy';

import { SIMPLE_HERO_LAYOUT, type SimpleHeroProps } from '../SimpleHero';

export const SIMPLE_HERO_HYDROCORTISONE_CONTENT: SimpleHeroProps = {
  header: (
    <React.Fragment>
      Hydrocortisone for <br />
      calmer skin
    </React.Fragment>
  ),
  body: 'Try new skincare with confidence. Hydrocortisone helps keep your skin comfortable as you introduce powerful active ingredients into your skincare routine.',
  ctaButton: {
    buttonText: 'Get your custom formula',
    disclaimerText: DISCLAIMER_CONSULTATION_RESULTS_INGREDIENTS_CANCEL,
  },
  media: (
    <StaticImage
      src="../images/headerHydrocortisoneDesktop@2x.jpg"
      alt="woman putting on custom formula"
      loading="eager"
    />
  ),
  layout: SIMPLE_HERO_LAYOUT.imageLast,
};
